import {Col, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import MDBox from "../../components/MDBox";
import {
  getAgeRangeTypes,
  getCompanyEventMatrixes,
  getEventLocations,
  getInventoryEvent,
  getInventoryEventTypes,
  getInventoryTypes,
  saveMassInventory
} from "../common/api/InventoryApi";
import MDButton from "../../components/MDButton";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import {Controller, useForm} from "react-hook-form";
import MDInput from "../../components/MDInput";
import {Chip, InputAdornment, NativeSelect, TextareaAutosize} from "@mui/material";
import {CONSTANTS} from "../common/constants";
import {DesktopTimePicker} from "@mui/x-date-pickers";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";

export default function ManageMassInventoryEventModal({
                                                        show, events, handleSave, handleClose
                                                      }) {

  const [context, setContext] = useContext(AppContext);
  const [fields, setFields] = useState([]);
  const statuses = [...CONSTANTS.STATUSES];

  const getEventFn = async (guid) => {
    return await getInventoryEvent(guid);
  }

  const [formInvalid, setFormInvalid] = useState(false);
  const [formSaving, setFormSaving] = useState(false);
  const [inventoryImage, setInventoryImage] = useState(null);
  const [removeImage, setRemoveImage] = useState(false);
  const [inventoryImageName, setInventoryImageName] = useState(null);
  const [inventoryImageType, setInventoryImageType] = useState(null);
  const [validImageSize, setValidImageSize] = useState(true);
  const [imageSize, setImageSize] = useState(0);
  const [removeIndex, setRemoveIndex] = useState(1);
  const [preview, setPreview] = useState(null);

  const removePreviewImage = () => {
    setRemoveImage(true);
    setImageSize(0);
    setInventoryImage(null);
    setValidImageSize(true);
    setPreview(null);
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPreview(null);
      setInventoryImageName(null);
      setInventoryImageType(null);
      setInventoryImage(null);
      setValidImageSize(true);
      setImageSize(0);
      return;
    }
    setImageSize(0);
    setInventoryImageName(file.name);
    setInventoryImageType(file.type);
    setValidImageSize(true);

    const reader = new FileReader();

    reader.onload = function (evt) {
      setImageSize(file.size);
      setValidImageSize((file.size / 1e6).toFixed(1) < 5);
      setInventoryImage(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);

    setPreview(URL.createObjectURL(file));
    setRemoveImage(false);
  }


  const isChecked = (id) => {
    return fields.indexOf(id) > -1;
  }

  const toggleField = (id) => {
    let newFields = [...fields];
    console.log('id ' + id);
    if (isChecked(id)) {
      newFields = fields.filter(a => a !== id);
    } else {
      newFields.push(id);
    }
    setFields(newFields)
  }

  const {register, handleSubmit, setValue, control} = useForm({});

  const [inventoryTypes, setInventoryTypes] = useState([]);
  const [eventLocation, setEventLocation] = useState();
  const [eventLocations, setEventLocations] = useState([]);
  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [ageRangeTypes, setAgeRangeTypes] = useState([]);
  const [inventoryType, setInventoryType] = useState(null);
  const [showMatrix, setShowMatrix] = useState(false);
  const [price, setPrice] = useState(0);

  const loadInventoryTypes = () => {
    getInventoryTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryTypes(result);
      }
    });
  };

  const defaultLocation = {id: -1, name: 'Select Location'};

  const loadEventLocations = () => {
    getEventLocations().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _locations = result;
        _locations.unshift(defaultLocation);
        setEventLocations(_locations);
      }
    });
  };

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryEventTypes(result);
      }
    });
  }

  const loadAgeRangeTypes = () => {
    getAgeRangeTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAgeRangeTypes(result);
      }
    });
  }

  const [eventMatrixes, setEventMatrixes] = useState(null);
  const [hasMatrix, setHasMatrix] = useState(false);

  const loadCompanyMatrixes = () => {
    getCompanyEventMatrixes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventMatrixes(result);
        if (result?.length > 0) {
          setHasMatrix(true);
        }
      }
    });
  }

  const handleFormSave = async (data) => {
    let d = {...data};
    d.inventoryImage = inventoryImage;
    d.inventoryImageName = inventoryImageName;
    d.inventoryImageType = inventoryImageType;
    if (data?.eventTime) {
      let _eventDate = new Date(data?.eventTime);
      d.eventTime = _eventDate;
    }
    if (data?.status?.id) {
      d.status = data.status;
    }
    if (data?.eventType?.id) {
      d.eventType = data.eventType;
    }
    if (data?.eventLocation?.id) {
      d.eventLocation = data.eventLocation;
    }
    if (data?.inventoryType?.id) {
      d.inventoryType = data.inventoryType;
    }
    if (data?.eventMatrix?.id) {
      d.eventMatrix = data.eventMatrix;
    }
    if (data?.ageRange?.id) {
      d.ageRange = data.ageRange;
    }

    let req = {
      inventory: d,
      fields: data.fields,
      inventoryGuids: events
    }
    setFormSaving(true);
    saveMassInventory(req).then((resp) => {
      setFormSaving(false);
      handleSave();
    });
  }

  const [allDayEvent, setAllDayEvent] = useState(false);
  const [eventDuration, setEventDuration] = useState(0);

  const [eventTime, setEventTime] = useState();
  const toggleAllDay = (e) => {
    setAllDayEvent(e.target.checked);
    if (e.target.checked) {
      setValue('eventDuration', 0);
      if (isChecked('fields.eventDuration')) {
        toggleField('fields.eventDuration');
      }
    }
  };

  useEffect(() => {
    // get inventory types
    loadInventoryTypes();
    loadInventoryEventTypes();
    loadAgeRangeTypes();
    loadEventLocations();
    loadCompanyMatrixes();
  }, []);

  return (
    <Modal onHide={handleClose} size={'xl'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'manageMassInventoryEventForm'}
            name={'manageMassInventoryEventForm'}>
        <Modal.Header closeButton>
          <Modal.Title>
            Manage Mass Events
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MDBox py={3}>
            <MDBox mb={3}>
              <div className={'row'}>
                <div className={'col col-12'}>
                  <Grid container spacing={3}>
                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.name')}
                                {...register('fields.name', {
                                  onChange: ((e) => {
                                    toggleField('fields.name')
                                  })
                                })} />
                    </Grid>
                    <Grid item xs={11} sm={5}>
                      <MDInput type="text" required={isChecked('fields.name')}
                               {...register('name')}
                               autoComplete="off"
                               disabled={!isChecked('fields.name')}
                               InputLabelProps={{shrink: true}}
                               className="form-control" id="name"
                               label={'Event Name'}
                               placeholder={'Enter Event Name'}/>
                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>

                      <Checkbox
                        checked={isChecked('fields.status')}
                        {...register('fields.status', {
                          onChange: ((e) => {
                            toggleField('fields.status')
                          })
                        })} />
                    </Grid>


                    <Grid item xs={11} sm={5}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="status"
                               className={"native-label"}>Status {isChecked('fields.status') ? '*' : ''}</label>
                        {statuses?.length && <NativeSelect
                          variant="outlined"
                          required={isChecked('fields.status')}
                          disabled={!isChecked('fields.status')}
                          id={'status'} name={'status'} className={'form-control'}
                          {...register('status.id', {
                            valueAsNumber: true,
                            required: isChecked('fields.status'),
                            min: 1,
                          })} defaultValue={-1}>
                          <option value={-1}>
                            Select Status
                          </option>
                          {
                            statuses?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.price')}
                                {...register('fields.price', {
                                  onChange: ((e) => {
                                    toggleField('fields.price')
                                  })
                                })} />
                    </Grid>
                    <Grid item xs={11} sm={5}>
                      {showMatrix && <>
                        <div className="form-group native-margin-fix" style={{
                          width: '100%',
                          marginTop: '-27px'
                        }}>
                          <label htmlFor="matrix" className={"native-label"}>Event Price Matrix *</label>
                          <Grid container>
                            <Grid item xs={10}>
                              {eventMatrixes?.length > 0 && <NativeSelect
                                sx={{
                                  clear: 'both',
                                  display: 'block',
                                }}
                                required={isChecked('fields.price')}
                                variant="outlined"
                                disabled={!isChecked('fields.price')}
                                id={'eventMatrix'} name={'eventMatrix'} className={'form-control'}
                                {...register('eventMatrix.id', {
                                  valueAsNumber: true,
                                  required: isChecked('fields.price'),
                                  min: 1,
                                })} defaultValue={-1}>
                                <option value={-1}>
                                  Select Event Price Matrix
                                </option>
                                {
                                  eventMatrixes
                                    .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                    .map((c) =>
                                      <option value={c.id} key={c.id}>
                                        {c.name}
                                      </option>)
                                }
                              </NativeSelect>}
                            </Grid>
                            <Grid item xs={2} justifyContent="flex-end" alignItems="flex-end"
                                  sx={{position: 'relative', border: 'solid 1px #ddd'}}>
                              <MDButton
                                onClick={() => {
                                  setShowMatrix(false);
                                }}
                                style={{
                                  width: '98%',
                                  height: '98%',
                                }}
                                iconOnly
                              >
                                <Icon>grid_on</Icon>
                              </MDButton>
                            </Grid>
                          </Grid>

                        </div>

                      </>}
                      {!showMatrix && <MDInput type="text" step="0.01" required={isChecked('fields.price')}
                                               {...register('price', {
                                                 valueAsDouble: true,
                                                 onChange: (e) => {
                                                   let v = e.target.value.replace(/[^0-9.]/g, '');
                                                   e.target.value = v;
                                                   setPrice(v)
                                                 }
                                               })}
                                               InputProps={{
                                                 startAdornment: <span className={'fa fa-dollar'}></span>,
                                                 endAdornment: <InputAdornment style={{
                                                   display: hasMatrix ? 'block' : 'none',
                                                   cursor: 'pointer',
                                                   height: '100%',
                                                   margin: '-10px 0',
                                                   padding: '5px 5px 5px 15px',
                                                   borderLeft: 'solid 1px #ddd',
                                                 }} position="end" onClick={(e) => {
                                                   setShowMatrix(!showMatrix);
                                                 }}>
                                                   {showMatrix ? <Icon>grid_on</Icon> :
                                                     <Icon>grid_off</Icon>}
                                                 </InputAdornment>
                                               }}
                                               InputLabelProps={{shrink: true}}
                                               disabled={!isChecked('fields.price')}
                                               defaultValue={'0.00'}
                                               autoComplete="off"
                                               name={'price'}
                                               className="form-control" id="price"
                                               label="Price"
                                               placeholder="Price"/>}

                    </Grid>
                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.eventLocation')}
                                {...register('fields.eventLocation', {
                                  onChange: ((e) => {
                                    toggleField('fields.eventLocation')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="eventLocation" className={"native-label"}>Event
                          Location {isChecked('fields.eventLocation') ? '*' : ''}</label>
                        {eventLocations?.length > 0 && <NativeSelect
                          variant="outlined"
                          required={isChecked('fields.eventLocation')}
                          disabled={!isChecked('fields.eventLocation')}
                          id={'eventLocation'} name={'eventLocation'} className={'form-control'}
                          {...register('eventLocation.id', {
                            valueAsNumber: true,
                          })}>
                          {
                            eventLocations.sort((a, b) => a.id - b.id).map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.inventoryType')}
                                {...register('fields.inventoryType', {
                                  onChange: ((e) => {
                                    toggleField('fields.inventoryType')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="inventoryType" className={"native-label"}>Inventory
                          Type {isChecked('fields.inventoryType') ? '*' : ''}</label>
                        {inventoryTypes?.length > 0 && <NativeSelect
                          required={isChecked('fields.inventoryType')}
                          variant="outlined"
                          disabled={!isChecked('fields.inventoryType')}
                          id={'inventoryType'} name={'inventoryType'} className={'form-control'}
                          {...register('inventoryType.id', {
                            valueAsNumber: true,
                            required: isChecked('fields.inventoryType'),
                            min: 1,
                          })} >
                          <option value={-1}>
                            Select Inventory Type
                          </option>
                          {inventoryTypes.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.eventType')}
                                {...register('fields.eventType', {
                                  onChange: ((e) => {
                                    toggleField('fields.eventType')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="eventType" className={"native-label"}>Event
                          Type {isChecked('fields.eventType') ? '*' : ''}</label>
                        {inventoryEventTypes?.length > 0 && <NativeSelect
                          required={isChecked('fields.eventType')}
                          variant="outlined"
                          disabled={!isChecked('fields.eventType')}
                          id={'eventType'} name={'eventType'}
                          className={'form-control'}
                          {...register('eventType.id', {
                            valueAsNumber: true,
                            required: isChecked('fields.eventType'),
                            min: 1,
                            onChange: (e) => {
                              // categoryChange(e.target.value)
                            }
                          })} >
                          <option value={-1}>
                            Select Event Type
                          </option>

                          {inventoryEventTypes.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                          }

                        </NativeSelect>}
                      </div>
                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.ageRange')}
                                {...register('fields.ageRange', {
                                  onChange: ((e) => {
                                    toggleField('fields.ageRange')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="ageRange" className={"native-label"}>Age
                          Range {isChecked('fields.ageRange') ? '*' : ''}</label>
                        {ageRangeTypes?.length > 0 && <NativeSelect
                          variant="outlined"
                          required={isChecked('fields.ageRange')}
                          disabled={!isChecked('fields.ageRange')}
                          id={'ageRange'} name={'ageRange'} className={'form-control'}
                          {...register('ageRange.id', {
                            valueAsNumber: true,
                          })} defaultValue={-1}>
                          {
                            ageRangeTypes
                              .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                              .map((c) =>
                                <option value={c.id} key={c.id}>
                                  {c.name}
                                </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.totalAvailable')}
                                disabled={allDayEvent}
                                {...register('fields.totalAvailable', {
                                  onChange: ((e) => {
                                    toggleField('fields.totalAvailable')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>

                      <MDInput type="number"
                               {...register('totalAvailable', {
                                 valueAsNumber: true,
                               })}
                               required={isChecked('fields.totalAvailable')}
                               disabled={!isChecked('fields.totalAvailable')}
                               min={0}
                               InputLabelProps={{shrink: true}}
                               label={"Event Attendees"}
                               defaultValue={0}
                               autoComplete="off"
                               className="form-control" id="totalAvailable"
                      />
                      <p className={'py-2 fw-light'}>
                        Attendees Size
                      </p>

                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.eventTime')}
                                {...register('fields.eventTime', {
                                  onChange: ((e) => {
                                    toggleField('fields.eventTime')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>
                      <Controller
                        name="eventTime"
                        control={control}
                        render={({field, fieldState}) => (
                          <DesktopTimePicker
                            disabled={!isChecked('fields.eventTime')}
                            label="Event Time"
                            value={field.value || null}
                            onChange={(newValue) => field.onChange(newValue)}
                            slotProps={{
                              textField: {
                                error: !!fieldState.error,
                                helperText: fieldState.error?.message
                              }
                            }}
                          />
                        )}
                      />

                      <label className={'form-check-label cursor-pointer'} htmlFor="allDay">
                        <Switch
                          style={{marginRight: '5px'}}
                          role={'switch'}
                          disabled={!isChecked('fields.eventTime')}
                          {...register('allDay',
                            {
                              onChange: (e) => {
                                toggleAllDay(e);
                              }
                            })}
                          id="allDay"/>
                        &nbsp;All Day
                      </label>

                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.eventDuration')}
                                disabled={allDayEvent}
                                {...register('fields.eventDuration', {
                                  onChange: ((e) => {
                                    toggleField('fields.eventDuration')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>

                      <MDInput type="number"
                               {...register('eventDuration', {
                                 valueAsNumber: true,
                               })}
                               required={isChecked('fields.eventDuration')}
                               disabled={allDayEvent || !isChecked('fields.eventDuration')}
                               min={1}
                               InputLabelProps={{shrink: true}}
                               label={"Event Duration"}
                               defaultValue={0}
                               autoComplete="off"
                               className="form-control" id="eventDuration"
                      />
                      <p className={'py-2 fw-light'}>
                        Length of Event in minutes
                      </p>

                    </Grid>

                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.inventoryImage')}
                                {...register('fields.inventoryImage', {
                                  onChange: ((e) => {
                                    toggleField('fields.inventoryImage')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={5}>
                      <div className="form-group">
                        <label htmlFor="inventoryImage"><small>Event Image</small></label>
                        <input type="file"
                               accept="image/*"
                               {...register('inventoryImage', {
                                 onChange: (e) => {
                                   handleFileChange(e);
                                 }
                               })}
                               disabled={!isChecked('fields.inventoryImage')}
                               autoComplete="off"
                               className="form-control" id="inventoryImage"/>
                        <div className={"clear clearfix"}>
                          <p className={!validImageSize ? 'pt-2 text-danger' : 'pt-2 fw-light'}>Maximum image size 5Mb
                            {!validImageSize ? ' Exceeded' : ''}</p>
                        </div>

                        {preview && <><img className={'img-thumbnail'} src={preview} alt="img"/>
                          <div>
                            <Chip label="Remove"
                                  style={{
                                    background: '#fff'
                                  }}
                                  className={'cls clear-both remove-button cursor-default'}
                                  variant="outlined" onClick={() => {
                              setInventoryImage(null);
                              setValidImageSize(true);
                              removePreviewImage();
                            }}/>
                          </div>
                        </>}

                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      &nbsp;
                    </Grid>
                    <Grid item xs={1} style={{
                      textAlign: 'right'
                    }}>
                      <Checkbox checked={isChecked('fields.eventDesc')}
                                {...register('fields.eventDesc', {
                                  onChange: ((e) => {
                                    toggleField('fields.eventDesc')
                                  })
                                })} />
                    </Grid>

                    <Grid item xs={11} sm={11}>

                      <div className="form-group native-margin-fix mt-1">
                        <label htmlFor="name"><small>Event Description</small></label>
                        <TextareaAutosize
                          disabled={!isChecked('fields.eventDesc')}
                          {...register('desc')}
                          autoComplete="off"
                          maxLength={4000}
                          minRows={3}
                          required={isChecked('fields.eventDesc')}
                          className="form-control" id="desc"
                          placeholder={'Enter Event Description'}/>
                      </div>
                    </Grid>

                  </Grid>


                </div>
              </div>
            </MDBox>
          </MDBox>

        </Modal.Body>

        <Modal.Footer>
          <Row className={'mt-2'}>
            <Col className={'col'} sm={12} xs={12}>
              <MDButton className={'pull-right'}
                        type="submit"
                        variant="gradient"
                        color="info"
                        form="manageMassInventoryEventForm"
                        disabled={formInvalid || formSaving}
              >
                {formSaving ? 'Saving...' : 'Save'}
              </MDButton>
            </Col>
          </Row>
        </Modal.Footer>
      </form>
    </Modal>
  );
}